import baseURL from "../components/authComponents/baseURL/BaseURL";

const PaymentService = {
  /**
   * Get payment history
   */
  async getHistory() {
    const token = localStorage.getItem("authToken");
    const response = await baseURL.get("/payments/history", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  /**
   * Submit a manual bank transfer payment with optional receipt
   * @param {string} plan - Plan key e.g. 'select_gold'
   * @param {string} currency - Should be 'pkr'
   * @param {File|null} receiptFile - Optional receipt screenshot file
   * @param {string|null} promoCode - Optional promo code for discount
   */
  async submitBankTransfer(plan, currency = "pkr", receiptFile = null, promoCode = null) {
    const token = localStorage.getItem("authToken");
    const formData = new FormData();
    formData.append("plan", plan);
    formData.append("currency", currency);
    if (receiptFile) {
      formData.append("receipt", receiptFile);
    }
    if (promoCode) {
      formData.append("promo_code", promoCode);
    }
    const response = await baseURL.post(
      "/payments/submit_bank_transfer",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  /**
   * Validate a promo code without redeeming
   * @param {string} code - Promo code
   * @param {string} planKey - Plan being purchased
   */
  async validatePromoCode(code, planKey) {
    const token = localStorage.getItem("authToken");
    const response = await baseURL.post(
      "/promo_codes/validate",
      { code, plan_key: planKey },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  /**
   * Get plan config from backend
   */
  async getPlansConfig() {
    const response = await baseURL.get("/plans/config");
    return response.data;
  },

  /**
   * Get full plan details for My Plan page
   */
  async getMyPlan() {
    const token = localStorage.getItem("authToken");
    const response = await baseURL.get("/payments/my_plan", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  /**
   * Get user's referral code
   */
  async getReferralCode() {
    const token = localStorage.getItem("authToken");
    const response = await baseURL.get("/referrals/my_code", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  /**
   * Claim a referral code
   */
  async claimReferral(code) {
    const token = localStorage.getItem("authToken");
    const response = await baseURL.post(
      "/referrals/claim",
      { referral_code: code },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
};

export default PaymentService;
